import { Button } from '@/components/ui/button'
import { useDaumPostcodePopup } from 'react-daum-postcode'

type Props = {
  onComplete: (address: string) => void
}

export const AddressSearchButton = ({ onComplete }: Props) => {
  const open = useDaumPostcodePopup(
    '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js',
  )

  const handleComplete = (data: any) => {
    let fullAddress = data.address
    let extraAddress = ''

    if (data.addressType === 'R') {
      if (data.bname !== '') {
        extraAddress += data.bname
      }
      if (data.buildingName !== '') {
        extraAddress +=
          extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName
      }
      fullAddress += extraAddress !== '' ? ` (${extraAddress})` : ''
    }
    onComplete(fullAddress)
  }

  const handleClick = () => {
    open({ onComplete: handleComplete })
  }

  return (
    <Button
      variant="outline"
      className="w-[100px] shrink-0"
      onClick={handleClick}
      type="button"
    >
      주소검색
    </Button>
  )
}
